export const SET_PAYMENT_IS_READY = 'SET_PAYMENT_IS_READY';
export const SET_STRIPE_TOKEN = 'SET_STRIPE_TOKEN';
export const SET_CARD_PUBKEY = 'SET_CARD_PUBKEY';
